export default __webpack_public_path__ + "static/plug-1960bf52fad39bd496fa4d7df46fb2e1.svg";